function AddToBagGrid(e) {
  var a = e;
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: {
      id: a,
      quantity: "1",
    },
    success: function () {
      $(".js-drawer-open-button-right").trigger("click");
    },
  });
}

$((function() {
  "true" == $("#site-header").attr("data-flush-header") ? $("#PageContainer").addClass("flush--enabled") : $("#PageContainer").addClass("flush--disabled"), $("#annoucement__bar").hasClass("annoucement__bar--true scroll--true") && "true" == $("#site-header").attr("data-flush-header") && $("#PageContainer").addClass("ac"), $("#annoucement__bar").hasClass("annoucement__bar--true scroll--false") && "true" == $("#site-header").attr("data-flush-header") && $("#PageContainer").addClass("ac"), $("#annoucement__bar").hasClass("annoucement__bar--true scroll--true") && "false" == $("#site-header").attr("data-flush-header") && ($("#PageContainer").addClass("ar"), $(".header__container").addClass("solid")), $("#annoucement__bar").hasClass("annoucement__bar--true scroll--false") && "false" == $("#site-header").attr("data-flush-header") && ($("#PageContainer").addClass("ar"), $(".header__container").addClass("solid")), $("#annoucement__bar").hasClass("annoucement__bar--false") && "true" == $("#site-header").attr("data-flush-header") && $("#PageContainer").addClass("pp"), $("#annoucement__bar").hasClass("annoucement__bar--false") && "false" == $("#site-header").attr("data-flush-header") && ($("#PageContainer").addClass("ad"), $(".header__container").addClass("solid"))
})), $((function() {
  var e = $("#site-header");
  $(window).scroll((function() {
    $(window).scrollTop() >= 50 ? e.removeClass("defaultHeader").addClass("scrolledHeader") : e.removeClass("scrolledHeader").addClass("defaultHeader")
  }))
})), $(".moveup").click((function() {
  $(".mobile-nav").addClass("menu-mobile-animate")
})), $(".moveout").click((function() {
  $(".mobile-nav").removeClass("menu-mobile-animate")
})), jQuery(".toggle .toggle-title").hasClass("active") && jQuery(".toggle .toggle-title.active").closest(".toggle").find(".toggle-inner").show(), jQuery(".toggle .toggle-title").click((function() {
  jQuery(this).hasClass("active") ? jQuery(this).removeClass("active").closest(".toggle").find(".toggle-inner").slideUp(200) : jQuery(this).addClass("active").closest(".toggle").find(".toggle-inner").slideDown(200)
})), $((function() {
  setTimeout(delayedFragmentTargetOffset, 500)
}));


jQuery(".mobile-site-nav .has-children > a").click(function (e) {
  e.preventDefault();
  jQuery(this).parent().toggleClass("is-open");
});
